import React from 'react';
import axios from '../axios';
import moment from 'moment';
import ModalAlert from '../redux/components/modal/modal_alert';

const SameEventCreation = (props) => {
  const [eventDate1, setEventDate1] = React.useState('');
  const [eventDate2, setEventDate2] = React.useState('');
  const [eventDate3, setEventDate3] = React.useState('');
  const [event1, setEvent1] = React.useState({});
  const [event2, setEvent2] = React.useState({});
  const [event3, setEvent3] = React.useState({});
  const [eventsPlans1, setEventsPlans1] = React.useState([]);
  const [eventsPlans2, setEventsPlans2] = React.useState([]);
  const [eventsPlans3, setEventsPlans3] = React.useState([]);
  const modalAlertSuccessRef = React.useRef(null);

  const eventDateTimeHour = moment(props.event.event_date).hour();
  const eventDateTimeMin = moment(props.event.event_date).minute();

  const diffEventEndDatetime = moment(props.event.event_end_datetime).diff(
    moment(props.event.event_date)
  );
  const diffApplicationDueDate = moment(props.event.application_due_date).diff(
    moment(props.event.event_date)
  );
  const diffAutoCanceledAt = moment(props.event.auto_canceled_at).diff(
    moment(props.event.event_date)
  );
  const diffPlansExpiredAtArray = props.eventsPlans.map((plan) =>
    plan.expired_at
      ? moment(plan.expired_at).diff(moment(props.event.event_date))
      : null
  );

  const isDesktop = window.innerWidth >= 768;
  const datetimeFormat = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';

  const submit = React.useCallback(async () => {
    if (!!eventDate1) {
      await updateEvent({
        eventId: event1.id,
        eventDate: eventDate1,
        eventsPlans: eventsPlans1,
      });
    }
    if (!!eventDate2) {
      await updateEvent({
        eventId: event2.id,
        eventDate: eventDate2,
        eventsPlans: eventsPlans2,
      });
    }
    if (!!eventDate3) {
      await updateEvent({
        eventId: event3.id,
        eventDate: eventDate3,
        eventsPlans: eventsPlans3,
      });
    }
    await modalAlertSuccessRef.current.openModal();
  }, [
    eventDate1,
    eventDate2,
    eventDate3,
    event1,
    event2,
    event3,
    eventsPlans1,
    eventsPlans2,
    eventsPlans3,
  ]);

  const createEvent = async ({ setEvent, setEventsPlans }) => {
    axios.post(`/api/event/${props.event.id}/dup`).then((response) => {
      if (response.data) {
        setEvent(response.data.event);
        setEventsPlans(response.data.events_plans);
      }
    });
  };

  const updateEvent = async ({ eventId, eventDate, eventsPlans }) => {
    const eventBody = JSON.stringify({
      event: {
        ...props.event,
        id: eventId,
        is_draft: false,
        delete_status: false,
        event_date: eventDate,
        event_end_datetime: moment(eventDate)
          .add(diffEventEndDatetime)
          .format(datetimeFormat),
        application_due_date: moment(eventDate)
          .add(diffApplicationDueDate)
          .format(datetimeFormat),
        auto_canceled_at: moment(eventDate)
          .add(diffAutoCanceledAt)
          .format(datetimeFormat),
      },
      events_plans: eventsPlans.map((plan, index) => ({
        ...plan,
        expired_at: diffPlansExpiredAtArray[index]
          ? moment(eventDate)
              .add(diffPlansExpiredAtArray[index])
              .format(datetimeFormat)
          : null,
      })),
    });

    await axios
      .post('/api/event_edit_submit/public', eventBody)
      .then((response) => {});
  };

  return (
    <div>
      <main
        className="bg-gray h-100 min-vh-100"
        style={{ paddingBottom: '144px' }}
      >
        <div className="shadow-sm py-2 mb-4 bg-white">
          <div className="container col-md-8 col-lg-6">
            <p className="text-fx-18px text-fw-bold">コピー元のイベント</p>
            <div className="row justify-content-between align-items-center">
              <p className="col-5 text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
                イベント名
              </p>
            </div>
            <p className="text-fw-bold mt-3 ml-3">{props.event.title}</p>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              イベント日時
            </p>
            <label className="row justify-content-between mt-3 mx-3 text-fz-14px text-fw-bold text-black-50">
              <p className="p-0 mb-0">開始時刻</p>
              <p>{moment(props.event.event_date).format(datetimeFormat)}</p>
            </label>
            <label className="row justify-content-between mx-3 text-fz-14px text-fw-bold text-black-50">
              <p className="pr-2 mb-0">終了時刻</p>
              <p>
                {moment(props.event.event_end_datetime).format(datetimeFormat)}
              </p>
            </label>
          </div>
        </div>

        <SelectBox
          eventDate={eventDate1}
          setEventDate={(value) => {
            setEventDate1(value);
            if (Object.keys(event1).length === 0) {
              createEvent({
                setEvent: (v) => setEvent1(v),
                setEventsPlans: (v) => setEventsPlans1(v),
              });
            }
          }}
          num={1}
          diffEventEndDatetime={diffEventEndDatetime}
          eventDateTimeHour={eventDateTimeHour}
          eventDateTimeMin={eventDateTimeMin}
        />
        <SelectBox
          eventDate={eventDate2}
          setEventDate={(value) => {
            setEventDate2(value);
            if (Object.keys(event2).length === 0) {
              createEvent({
                setEvent: (v) => setEvent2(v),
                setEventsPlans: (v) => setEventsPlans2(v),
              });
            }
          }}
          num={2}
          diffEventEndDatetime={diffEventEndDatetime}
          eventDateTimeHour={eventDateTimeHour}
          eventDateTimeMin={eventDateTimeMin}
        />
        <SelectBox
          eventDate={eventDate3}
          setEventDate={(value) => {
            setEventDate3(value);
            if (Object.keys(event3).length === 0) {
              createEvent({
                setEvent: (v) => setEvent3(v),
                setEventsPlans: (v) => setEventsPlans3(v),
              });
            }
          }}
          num={3}
          diffEventEndDatetime={diffEventEndDatetime}
          eventDateTimeHour={eventDateTimeHour}
          eventDateTimeMin={eventDateTimeMin}
        />
        <div className="container col-md-8 col-lg-6 mt-5">
          <div
            className="w-100"
            style={{ paddingRight: '10px', paddingLeft: '10px' }}
          >
            <button
              type="button"
              className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
              value="semi_official"
              onClick={() => submit()}
            >
              コピーしてイベントを公開する
            </button>
          </div>
        </div>
      </main>
      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertSuccess"
        title="イベント作成完了"
        content={'イベントを作成しました。'}
        approveFunc={() => {
          window.location.href =
            '/circle/' + props.event.circle_id + '/events/' + props.event.id;
        }}
      />
    </div>
  );
};

const SelectBox = ({
  eventDate,
  setEventDate,
  num,
  diffEventEndDatetime,
  eventDateTimeHour,
  eventDateTimeMin,
}) => {
  const title =
    num === 1
      ? 'コピー先の日付①'
      : num === 2
      ? 'コピー先の日付②'
      : 'コピー先の日付③';

  const maxMoment = moment().add(6, 'months');

  const minDatePicker = moment().format('YYYY/MM/DD');
  const maxDatePicker = maxMoment.format('YYYY/MM/DD');
  const maxDateTimeLocal = maxMoment.format('YYYY-MM-DDTHH:mm');

  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      $('.datetimepicker').each(function () {
        $(this).datetimepicker({
          format: 'Y/m/d',
          lang: 'ja',
          scrollInput: true,
          timepicker: false,
          minDate: minDatePicker,
          maxDate: maxDatePicker,
        });
      });
    }
  }, [maxDatePicker]);

  const isDesktop = window.innerWidth >= 768;
  const datetimeFormType = isDesktop ? 'text' : 'datetime-local';
  const datetimeFormat = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';

  return (
    <div className="shadow-sm py-2 mb-4 bg-white">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          {title}
        </p>
        <label className="row justify-content-between mt-3 mx-3">
          <p className="p-0 mb-0 text-fz-14px text-fw-bold">開始時刻</p>
          <input
            type={datetimeFormType}
            className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray text-fz-14px text-fw-bold"
            id="event-start-datetime-input-form"
            value={eventDate ? moment(eventDate).format(datetimeFormat) : ''}
            onChange={(e) => {
              setEventDate(
                moment(e.target.value)
                  .set({
                    hour: eventDateTimeHour,
                    minute: eventDateTimeMin,
                  })
                  .format(datetimeFormat)
              );
            }}
            onBlur={(e) => {
              setEventDate(
                moment(e.target.value)
                  .hours(eventDateTimeHour)
                  .minutes(eventDateTimeMin)
                  .format(datetimeFormat)
              );
            }}
            placeholder="必須"
            autoComplete="off"
            {...(!isDesktop && {
              max: maxDateTimeLocal,
            })}
          />
        </label>
        <label className="row justify-content-between mt-3 mx-3">
          <p className="p-0 mb-0 text-fz-14px text-fw-bold">終了時刻</p>
          <p className="text-fz-14px text-fw-bold">
            {eventDate
              ? moment(eventDate)
                  .add(diffEventEndDatetime)
                  .format(datetimeFormat)
              : ''}
          </p>
        </label>
      </div>
    </div>
  );
};

export default SameEventCreation;
